import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Home, Phone, Mail } from 'lucide-react';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData;

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-6">
      <Card className="max-w-2xl w-full border-4 border-green-200 shadow-2xl">
        <CardContent className="p-12 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-green-100 p-6 rounded-full">
              <CheckCircle className="h-24 w-24 text-green-600" />
            </div>
          </div>

          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Order Submitted Successfully!
          </h1>

          <p className="text-xl text-gray-700 mb-8">
            Thank you for choosing Netix Fibernet!
          </p>

          <div className="bg-blue-50 p-6 rounded-xl mb-8 text-left">
            <h2 className="text-lg font-bold text-gray-900 mb-3">What's Next?</h2>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
                <span>A confirmation email has been sent to your registered email address</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
                <span>Our team will review your request and contact you within 24 hours</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
                <span>We'll schedule the installation at your preferred time</span>
              </li>
            </ul>
          </div>

          {orderData?.orderId && (
            <div className="bg-yellow-50 p-4 rounded-lg mb-8">
              <p className="text-sm text-gray-600 mb-1">Your Order Reference ID</p>
              <p className="text-2xl font-bold text-gray-900">{orderData.orderId}</p>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              size="lg"
              className="bg-gradient-to-r from-blue-600 to-blue-700"
            >
              <Home className="h-5 w-5 mr-2" />
              Back to Home
            </Button>
            <Button
              onClick={() => window.location.href = 'tel:+919319919988'}
              data-testid="order-success-call-mobile-button"
              size="lg"
              variant="outline"
              className="border-2"
            >
              <Phone className="h-5 w-5 mr-2" />
              Call Support
            </Button>
            <Button
              onClick={() => window.location.href = 'tel:06276459015'}
              data-testid="order-success-call-office-button"
              size="lg"
              variant="outline"
              className="border-2"
            >
              <Phone className="h-5 w-5 mr-2" />
              Office Phone
            </Button>
          </div>

          <div className="mt-8 pt-8 border-t">
            <p className="text-sm text-gray-600 mb-2">Need immediate assistance?</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center text-sm">
              <div className="flex items-center gap-2 text-gray-700">
                <Phone className="h-4 w-4 text-red-600" />
                <span data-testid="order-success-mobile">+91 93199 19988</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Phone className="h-4 w-4 text-red-600" />
                <span data-testid="order-success-office-phone">Office: 06276 - 459015</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Mail className="h-4 w-4 text-red-600" />
                <span>care@netixfibernet.com</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OrderSuccess;
